import styled from "styled-components";

export const StyledFooter = styled.footer`
  position: relative;
  background: var(--field-color);
  box-shadow: 2px -10px 30px rgba(37, 89, 141, 0.25);
  color: var(--white-color);
  a {
    color: var(--white-color);
  }
`;

export const StyledBuletsRectangleImg = styled.img`
  position: absolute;
  z-index: 0;
  transform: scale(0.8);
  right: ${({ right }) => right && "5%"};
  top: ${({ right }) => right && "2rem"};
  bottom: ${({ left }) => left && "10%"};
  left: ${({ left }) => left && "0"};
  @media screen and (max-width: 1200px) {
    right: ${({ right }) => right && "-30px"};
  }
  @media screen and (max-width: 576px) {
    bottom: ${({ left }) => left && "50%"};
    width: 35%;
  }
`;

export const FooterTop = styled.div``;
export const FooterButtom = styled.div``;

export const StyledH5 = styled.h5`
  font-size: var(--font-size-lg);
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-base);
  }
  position: relative;
  width: max-content;
  &::before {
    content: "";
    opacity: 0.4;
    width: 100%;
    height: 1px;
    background-color: var(--white-color);
    position: absolute;
    right: 0;
    bottom: -10px;
  }
`;

export const StyledContactLi = styled.li`
  a {
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
    transition: all ease 0.5s;
    opacity: 0.75;
    &:hover {
      transform: translateY(-2px);
      opacity: 1;
    }
  }
`;

export const CertificateImg = styled.img`
  max-height: 100%;
  width: 100%;
`;

export const StyledCopyright = styled.p`
  font-size: var(--font-size-xs);
`;

export const SocialLi = styled.li`
  background: var(--secondary-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  position: relative;
  a {
    color: var(--tertiary-color);
    .icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
